var _circle, _circle2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgValores1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 150,
    viewBox: "0 0 155 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 81,
    cy: 76,
    r: 72,
    stroke: "#0885C7",
    strokeWidth: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#FFCD00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3865 31.2V34H19.0115V31.2H22.5115V22.0125C22.5115 21.7792 22.5157 21.5458 22.524 21.3125C22.5324 21.0708 22.5449 20.8292 22.5615 20.5875L20.4865 22.3125C20.3032 22.4542 20.1199 22.5417 19.9365 22.575C19.7615 22.6 19.5949 22.6 19.4365 22.575C19.2782 22.5417 19.1365 22.4875 19.0115 22.4125C18.8865 22.3292 18.7949 22.2458 18.7365 22.1625L17.5115 20.5375L23.1865 15.775H26.3865V31.2H29.3865Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81 38L93.3603 63.1099L121 67.136L101 86.6814L105.721 114.279L81 101.25L56.2781 114.279L61 86.6814L41 67.136L68.6397 63.1099L81 38Z",
    fill: "#0885C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValores1);
export default __webpack_public_path__ + "static/media/valores_1.e703b748e332f2db7ad361e671f70dbe.svg";
export { ForwardRef as ReactComponent };